<template>
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myLargeModalLabel" style="font-size: 14px;">Importador de Empleados</h4>
                <button ref="closeEmployeesImportModal" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form id="import_file_form" method="POST" enctype="multipart/form-data">
                    <div class="form theme-form">
                        <div class="row">
                            <div class="col-sm-12" style="padding: 0px 10px;">
                                <div class="mb-3">
                                    <label>Archivo a Importar</label>
                                    <input class="form-control" type="file" id="import_file" name="import_file" placeholder="">
                                </div>
                            </div>
                        </div> 
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button class="btn btn-primary btn-sm" type="button" style="float: right;" title="btn btn-success btn-sm" @click="importEmployees">Importar</button>
            </div>
        </div>
    </div>
</template>
<script>
import ws from '@/services/employees'
 
export default {
    name: 'employees_import_modal',
    mixins: [],
    props: {

    },
    components: {
        
    },
    data(){
        return{
            showModal: true
        }
    },
    methods: {
        async importEmployees() {
            const form = document.getElementById("import_file_form");
            const formData = new FormData(form);

            let response = await ws.importEmployees(formData);

            if(response.type == "success"){
                this.$toast.success(response.message);

                this.closeModal();

                this.$emit("imported",response.data);
            }
            else{
                this.$toast.error(response.message);
            }
        },
        closeModal(){
            this.$refs.closeEmployeesImportModal.click();
        }
    }
}
</script>